import { createSlice } from '@reduxjs/toolkit'
import { plus } from 'number-precision'
import { limboGamePlacedBet, getLimboGameBetRecord } from 'games/Limbo/slice-thunk/limboGame.thunk'

const initialState = {
  loading: false,
  limboBetHistory: null,
  betResult: null,
  wins: 0,
  losses: 0,
  profit: 0,
  wagered: 0,
  showLimboHistory: false,
  betHistoryData: null,
  strategyInputs: {
    stopOnProfit: 0,
    stopOnLoss: 0,
    maxBetAmount: 0,
    onWinEnabled: false,
    onWinIncreasePercent: 0,
    onLossEnabled: false,
    onLossIncreasePercent: 0
  }
}

const {
  actions: {
    setLimboBetHistory,
    resetLimboGameResult,
    setLimboLossCount,
    setLimboWinsCount,
    setProfit,
    setWagered,
    setBetHistoryData,
    resetLiveStats,
    setStrategyInputs,
    setDemoGameResult
  },
  reducer
} = createSlice({
  name: 'limboGame',
  initialState,
  reducers: {
    setBetHistoryData: (state, action) => ({
      ...state,
      betHistoryData: action.payload,
      showLimboHistory: !!action.payload
    }),
    setLimboBetHistory: (state, action) => ({
      ...state,
      limboBetHistory: action?.payload
    }),
    resetLimboGameResult: (state, action) => ({
      ...state,
      betResult: null
    }),
    setLimboWinsCount: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          wins: action.payload.reset
        }
      }
      return {
        ...state,
        wins: state.wins + 1
      }
    },
    setLimboLossCount: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          losses: action.payload.reset
        }
      }
      return {
        ...state,
        losses: state.losses + 1
      }
    },
    setProfit: (state, action) => {
      return {
        ...state,
        profit: plus(state.profit, action.payload)
      }
    },
    setWagered: (state, action) => {
      return {
        ...state,
        wagered: plus(state.wagered, action.payload)
      }
    },
    resetLiveStats: (state, action) => {
      return {
        ...state,
        wins: 0,
        losses: 0,
        profit: 0,
        wagered: 0
      }
    },
    setStrategyInputs: (state, action) => {
      return {
        ...state,
        strategyInputs: action.payload
      }
    },
    setDemoGameResult: (state, action) => {
      return {
        ...state,
        betResult: action?.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(limboGamePlacedBet.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(limboGamePlacedBet.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          betResult: action?.payload
        }
      })
      .addCase(limboGamePlacedBet.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
      .addCase(getLimboGameBetRecord.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(getLimboGameBetRecord.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          limboBetHistory: action?.payload
        }
      })
      .addCase(getLimboGameBetRecord.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
  }
})

export {
  setLimboBetHistory,
  resetLimboGameResult,
  setLimboWinsCount,
  setLimboLossCount,
  setProfit,
  setWagered,
  setBetHistoryData,
  resetLiveStats,
  setStrategyInputs,
  setDemoGameResult
}

export default reducer
